<template>
  <v-container>
    <DashboardHeader></DashboardHeader>
    <v-row>
      <v-col>
        <h1>Project dashboard</h1>
        <v-select
          v-model="project"
          :items="projecten"
          solo
          dense
          :hide-details="true"
          :return-object="true"
          class="project-select"
          flat
          @change="projectchanged"
          item-text="Naam"
          menu-props="auto"
        ></v-select>
      </v-col>
      <v-col>
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon @click="periodeterug()" v-on="on">mdi-arrow-left-bold</v-icon>
            </template>
            <span>{{periodeeenheid}} terug</span>
          </v-tooltip>
          <v-select
            v-model="periodeeenheid"
            :items="periodeeenheden"
            solo
            dense
            :hide-details="true"
            class="periode-select ps-smal"
            flat
            @change="scopechanged"
          ></v-select>
          <v-select
            v-model="week"
            :items="weken"
            solo
            dense
            item-text="Naam"
            v-show="periodeeenheid == 'Week'"
            :return-object="true"
            :hide-details="true"
            class="periode-select ps-breed"
            flat
            @change="scopechanged"
            menu-props="auto"
          ></v-select>
          <v-select
            v-model="maand"
            :items="maanden"
            solo
            dense
            item-text="Naam"
            v-show="periodeeenheid == 'Maand'"
            :return-object="true"
            :hide-details="true"
            flat
            class="periode-select ps-breed"
            @change="scopechanged"
            menu-props="auto"
          ></v-select>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon @click="periodeverder()" v-on="on">mdi-arrow-right-bold</v-icon>
            </template>
            <span>{{periodeeenheid}} vooruit</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon @click="vandaag()" v-on="on">mdi-calendar-today</v-icon>
            </template>
            <span>Naar huidige {{periodeeenheid.toLowerCase()}}</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>

    <v-tabs vertical>
      <v-tab>Overzicht</v-tab>
      <v-tab>Factoren</v-tab>

      <v-tab-item>
        <v-card flat tile>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" align="center">
                <h2 class="mb-12">Ongevallen</h2>
                <ProjectOngevallen
                  :periode="periode"
                  :project="project"
                  :periodeeenheid="periodeeenheid"
                ></ProjectOngevallen>
              </v-col>
              <v-col cols="12" md="8">
                <h2 class="mb-12">Acties</h2>
                <v-card>
                  <v-card-text>
                    <ProjectActies :periode="periode" :project="project"></ProjectActies>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat tile>
          <v-card-text>
            <ProjectFactorenEenvoudig
              :periode="periode"
              :project="project"
              :periodeeenheid="periodeeenheid"
            ></ProjectFactorenEenvoudig>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import ProjectActies from "@/components/dashboards/components/ProjectActies.vue";
import ProjectOngevallen from "@/components/dashboards/components/ProjectOngevallen.vue";
import ProjectFactorenEenvoudig from "@/components/dashboards/components/ProjectFactorenEenvoudig.vue";
import DashboardHeader from "@/components/dashboards/components/DashboardHeader.vue";

export default {
  name: "ProjectDashboard",
  components: {
    ProjectActies,
    ProjectOngevallen,
    ProjectFactorenEenvoudig,
    DashboardHeader
  },
  data: () => ({
    periodeeenheden: ["Week", "Maand"],
    weken: [],
    maanden: [],
    periodeeenheid: "Week",
    week: null,
    maand: null,
    periode: 0,
    projecten: [],
    project: null
  }),
  methods: {
    loadPeriodes: function() {
      this.$api
        .pProjectGetMaanden({ ProjectId: this.project.Id })
        .then(response => {
          this.maanden = response.data;
          if (this.maanden.length > 0)
            this.maand = this.maanden[this.maanden.length - 1];
          if (this.periodeeenheid == "Maand") this.scopechanged();
        });
      this.$api
        .pProjectGetWeken({ ProjectId: this.project.Id })
        .then(response => {
          this.weken = response.data;
          if (this.weken.length > 0)
            this.week = this.weken[this.weken.length - 1];
          if (this.periodeeenheid == "Week") this.scopechanged();
        });
    },
    loadProjecten: function() {
      this.$api.pGetProjectList().then(response => {
        this.projecten = response.data;
        if (this.projecten.length > 0) {
          this.project = this.projecten[0];
          this.loadPeriodes();
          // this.scopechanged();
        }
      });
    },
    scopechanged: function() {
      if (this.periodeeenheid == "Week") {
        this.periode = this.week.Id;
      } else {
        this.periode = this.maand.Id;
      }
      // this.refreshOngevallen(); Is nu component
    },
    projectchanged: function() {
      this.loadPeriodes();
    },
    periodeverder: function() {
      // Blader periode verder
      if (this.periodeeenheid == "Week" && this.week != null) {
        let idx = this.weken.indexOf(this.week);
        if (idx != -1 && idx < this.weken.length - 1) {
          this.week = this.weken[idx + 1];
          this.scopechanged();
        }
      }
      if (this.periodeeenheid == "Maand" && this.maand != null) {
        let idx = this.maanden.indexOf(this.maand);
        if (idx != -1 && idx < this.maanden.length - 1) {
          this.maand = this.maanden[idx + 1];
          this.scopechanged();
        }
      }
    },
    periodeterug: function() {
      // Blader periode terug
      if (this.periodeeenheid == "Week" && this.week != null) {
        let idx = this.weken.indexOf(this.week);
        if (idx != -1 && idx > 0) {
          this.week = this.weken[idx - 1];
          this.scopechanged();
        }
      }
      if (this.periodeeenheid == "Maand" && this.maand != null) {
        let idx = this.maanden.indexOf(this.maand);
        if (idx != -1 && idx > 0) {
          this.maand = this.maanden[idx - 1];
          this.scopechanged();
        }
      }
    },
    vandaag: function() {
      // Vandaag is onderste in combo
      if (this.periodeeenheid == "Week")
        this.week = this.weken[this.weken.length - 1];
      if (this.periodeeenheid == "Maand")
        this.maand = this.maanden[this.maanden.length - 1];
      this.scopechanged();
    }
  },
  mounted() {
    this.loadProjecten();
  }
};
</script>

<style scoped>
.Ongevallen {
  font-size: 42px;
  font-weight: bold;
}

.OngevallenChange {
  position: relative;
  top: -8px;
}

.OngevalIcon {
  position: relative;
  top: -10px;
}
.periode-select {
  display: inline-block;
}
.ps-smal {
  width: 110px;
}
.ps-breed {
  width: 200px;
}

.project-select {
  display: inline-block;
  width: 300px;
}

.card-ongevallen {
  min-height: 130px;
}

.card-vorigeperiode {
  min-height: 200px;
}
</style>